import type { MedicationData } from "@qendo/medical/medication";
import { MedicalType } from "@qendo/medical/types";
import type { DosageData } from "@qendo/medication";
import type { ScheduleData } from "@qendo/schedule";
import type { DateArg } from "date-fns";
import Data from "~/util/data";

export class Medication extends Data implements MedicationData {
    public readonly type = MedicalType.medication;

    public constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public prescribed = false,
        public current = false,
        public start_date: string | DateArg<Date> | null = null,
        public end_date: string | DateArg<Date> | null = null,
        public dosage: DosageData | null = null,
        public schedule: ScheduleData | null = null,
    ) {
        super();
    }
}
